export const INLINE_RATING = 'inline_rating'
export const REVIEW_HIGHLIGHTS = 'review_highlights'
export const REVIEWS = 'reviews'
export const RATING_SUMMARY = 'rating_summary'
export const QUESTIONS = 'questions'
